module.exports = __webpack_public_path__ + "static/media/3DepartmentOfMuseumMalaysia.3d7e0c06.jpg";